import * as actionCreator from "./actionCreator";
import * as reducer from "./reducer.supportEditor";

export const actions = {
    ...actionCreator
}

export const reducers = {
    posts: reducer.reducer
}

export * from "./actions"
export * from "./models"
